
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.812 11.82A6.123 6.123 0 01-.07 6.626 6.128 6.128 0 016.055.5a6.12 6.12 0 015.063 2.68A6.123 6.123 0 0114 8.374 6.128 6.128 0 017.875 14.5a6.12 6.12 0 01-5.058-2.671l-.005-.008zm5.063-8.987a5.544 5.544 0 015.542 5.542 5.545 5.545 0 01-5.542 5.542 5.544 5.544 0 01-5.542-5.542 5.544 5.544 0 015.542-5.542zm.292 8.75H7.57v-.508c-1.367-.176-1.516-1.27-1.516-1.6h.636c.015.236.092 1.034 1.273 1.034.35 0 .635-.082.848-.244.21-.161.313-.357.313-.6 0-.463-.3-.798-1.208-1.002-1.381-.313-1.705-.816-1.705-1.478 0-.88.713-1.293 1.36-1.403v-.615h.595v.592c1.453.113 1.572 1.292 1.572 1.616h-.64c0-.677-.536-1.03-1.165-1.03-.628 0-1.082.31-1.082.821 0 .456.256.68 1.164.907 1.096.276 1.749.642 1.749 1.564 0 1.017-.88 1.396-1.598 1.454v.492zM9.829 2.57a5.52 5.52 0 00-3.774-1.486A5.544 5.544 0 00.513 6.625c0 1.536.626 2.927 1.637 3.931l-.002-.006A6.128 6.128 0 019.829 2.57z","fill":"currentColor"}})])
          )
        }
      }
    